import dynamic from 'next/dynamic';

const PerksPage = dynamic(() => import('../../js/pages/PerksInfoPage'), {ssr: false});

export default PerksPage;
